{
  "replaceMessage": "Kukuta fail asendamiseks"
}
